import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import styles from './ActiveDeliveriesOtpPage.module.less';
import ActiveDeliveryCards from '../../components/ActiveDeliveriesCards/ActiveDeliveriesCards';
import { routes } from '../../utils/routerHelper';
import {
  whenOrderIsCanceled,
  whenOrderIsFailedToCancel,
  whenOrderIsFailedToRecreate,
  whenOrderIsRecreated
} from '../deliveries/messages';
import { getErrorFromResponse } from '../../utils/apiHelpers';
import Page from '../../components/Page/Page';
import { ACTIVE_DELIVERY_TYPE } from '../../api/deliveries';

export class ActiveDeliveriesOtpPage extends Component {
  REFRESH_INTERVAL = 15 * 1000;
  selectedCardRef = createRef(null);

  componentDidMount() {
    this.props.fetchActiveDeliveries(ACTIVE_DELIVERY_TYPE.OTP);
    this._intervalId = setInterval(
      () => this.props.fetchActiveDeliveries(ACTIVE_DELIVERY_TYPE.OTP),
      this.REFRESH_INTERVAL
    );
    this.tryToScroll();
  }

  componentDidUpdate(prevProps) {
    const { activeDeliveries } = this.props;
    const deliveryListWasLoaded = !prevProps.activeDeliveries?.length && activeDeliveries?.length;
    if (deliveryListWasLoaded) {
      this.tryToScroll();
    }
  }

  /**
   * scrolls to the selected delivery
   * if there is no selected delivery (e.g. delivery list was not loaded yet) does nothing
   */
  tryToScroll() {
    this.selectedCardRef?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  componentWillUnmount() {
    clearInterval(this._intervalId);
  }

  onRecreateDelivery = bookingId => {
    return this.props
      .recreateDeliveryAndFetch(bookingId)
      .then(() => {
        this._postOrderCreation();
        this.props.history.push(routes.activeDeliveriesOtp);
      })
      .catch(error => {
        this._postOrderCreation(error);
      });
  };

  _postOrderCreation = error => {
    if (!error) {
      whenOrderIsRecreated();
    } else {
      whenOrderIsFailedToRecreate(getErrorFromResponse(error));
    }
  };
  onCancelOtp = bookingId => {
    return this.props
      .cancelOtp(bookingId, ACTIVE_DELIVERY_TYPE.OTP)
      .then(() => {
        this._postOrderCancellation();
        this.props.history.push(routes.activeDeliveriesOtp);
      })
      .catch(error => {
        this._postOrderCancellation(error);
      });
  };
  _postOrderCancellation = error => {
    if (!error) {
      whenOrderIsCanceled();
    } else {
      whenOrderIsFailedToCancel(getErrorFromResponse(error));
    }
  };

  handleExpandClick = deliveryId => {
    if (!deliveryId) {
      this.props.history.push(routes.activeDeliveriesOtp);
    } else {
      this.props.history.push(routes.activeDeliveriesOtpWithParam.replace(':deliveryId', deliveryId));
    }
  };

  getSelectedDelivery() {
    const { match, activeDeliveries } = this.props;
    return (
      match.params?.deliveryId && activeDeliveries?.find(delivery => delivery.id === Number(match.params.deliveryId))
    );
  }

  render() {
    const { activeDeliveries, deliveriesTrackingDataById, match } = this.props;
    return (
      <Page>
        <div className={styles.container}>
          <div className={styles.cardsContainer}>
            <ActiveDeliveryCards
              deliveries={activeDeliveries}
              trackingData={deliveriesTrackingDataById}
              onRecreateDelivery={this.onRecreateDelivery}
              onCancelDelivery={this.onCancelOtp}
              selectedDeliveryId={Number(match.params?.deliveryId) || undefined}
              selectedCardRef={this.selectedCardRef}
              handleExpandClick={this.handleExpandClick}
              onCancelDeliveryAbort={() => {}}
              onCancelDeliveryAttempt={() => {}}
            />
          </div>
        </div>
      </Page>
    );
  }
}

ActiveDeliveriesOtpPage.propTypes = {
  activeDeliveries: PropTypes.arrayOf(PropTypes.any),
  deliveriesTrackingDataById: PropTypes.object,
  defaultPickupLocation: PropTypes.object,
  fetchActiveDeliveries: PropTypes.func,
  cancelOtp: PropTypes.func,
  recreateDeliveryAndFetch: PropTypes.func,
  match: PropTypes.any,
  history: PropTypes.any
};

const mapState = ({
  deliveries: { activeDeliveries, deliveriesTrackingDataById },
  user: { defaultPickupLocation }
}) => ({
  activeDeliveries,
  deliveriesTrackingDataById,
  defaultPickupLocation
});

const mapDispatch = ({ deliveries: { fetchActiveDeliveries, recreateDeliveryAndFetch, cancelOtp } }) => ({
  fetchActiveDeliveries,
  recreateDeliveryAndFetch,
  cancelOtp
});

export default connect(mapState, mapDispatch)(withRouter(ActiveDeliveriesOtpPage));
